module.exports = __webpack_public_path__ + "static/media/terracotta@2x.981134a1.png";